(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _service = __webpack_require__(2);
	
	var _service2 = _interopRequireDefault(_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $resolveProvider = function () {
	  function $resolveProvider() {
	    _classCallCheck(this, $resolveProvider);
	
	    this.defaults = {
	      propertyName: '$resolves',
	      ev: '$stateChangeSuccess'
	    };
	  }
	
	  _createClass($resolveProvider, [{
	    key: '$get',
	    value: ["$rootScope", "$state", function $get($rootScope, $state) {
	      'ngInject';
	
	      return new _service2.default({ $rootScope: $rootScope, $state: $state }, this.defaults);
	    }]
	  }]);
	
	  return $resolveProvider;
	}();
	
	exports.default = $resolveProvider;
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $resolvesService = function () {
	  function $resolvesService(_ref, defaults) {
	    var $rootScope = _ref.$rootScope;
	    var $state = _ref.$state;
	
	    _classCallCheck(this, $resolvesService);
	
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.defaults = defaults;
	
	    if (this.defaults.propertyName) {
	      this.$rootScope[this.defaults.propertyName] = {};
	    }
	
	    this.init = this.$$init();
	  }
	
	  _createClass($resolvesService, [{
	    key: "$$init",
	    value: function $$init() {
	      var _this = this;
	
	      return this.$rootScope.$on(this.defaults.ev, function () {
	        var globals = undefined;
	        try {
	          globals = _this.$state.$current.locals.globals;
	        } catch (err) {
	          globals = {};
	        }
	
	        for (var name in globals) {
	          var value = globals[name];
	          _this[name] = value;
	          if (_this.defaults.propertyName) {
	            angular.extend(_this.$rootScope[_this.defaults.propertyName], _defineProperty({}, name, value));
	          }
	        }
	      });
	    }
	  }, {
	    key: "$$deregister",
	    value: function $$deregister() {
	      (this.init || angular.noop)();
	    }
	  }]);
	
	  return $resolvesService;
	}();
	
	exports.default = $resolvesService;
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _provider = __webpack_require__(1);
	
	var _provider2 = _interopRequireDefault(_provider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = angular.module('ui.router.$resolve', ['ui.router']).provider('$resolves', _provider2.default).run(["$resolves", function ($resolves) {}]);
	
	exports.default = _module.name;
	_module.exports = exports['default'];

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** angular-ui-router-resolve.js
 **/